"use client";

import React from "react";
import { Toaster as SonnerToaster, toast } from "sonner";

const Toaster = () => {
  return (
    <SonnerToaster
      className="toaster group"
      closeButton
      swipeDirections={["top", "right"]}
      // KAN-мобилка: на мобиле (<=600px) sonner растягивает тост на всю
      // ширину и прижимает к нижнему краю вьюпорта дефолтным отступом —
      // на iPhone учитываем отступ для системного жеста «домой».
      mobileOffset={{ bottom: "calc(16px + env(safe-area-inset-bottom))" }}
      toastOptions={{
        style: { paddingRight: "2.75rem" },
        classNames: {
          toast:
            "rounded-xl border border-border/80 bg-popover text-popover-foreground shadow-lg",
          title: "text-sm font-medium",
          description: "text-xs text-muted-foreground mt-0.5",
          closeButton: "!top-2 !size-6 !rounded-md",
          success: "border-primary/20",
          error: "border-destructive/30",
          info: "border-primary/10",
        },
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--toast-close-button-start": "unset",
          "--toast-close-button-end": "8px",
          "--toast-close-button-transform": "none",
        } as React.CSSProperties
      }
    />
  );
};

export { Toaster, toast };
